export function bottleTopsEnglish(input) {
  return {
    'twist_off': 'twist off',
  }[input] || '';
};

var filter = function() {
  return bottleTopsEnglish
};

filter.$inject = [];

tiz.filter('bottleTopsEnglish', filter);

